import "../../styles/global.scss";

import { inject, observer } from "mobx-react";

import { Button } from "antd";
import React from "react";
import { some } from "lodash";

@inject("store")
@observer
class OptionList extends React.Component {
  handleClick = (name) => {
    const {
      store: {
        ProfileStore: { changeSelectedAction, userId },
        MemberListStore: { clearAssignInfo },
      },
      user,
      usernamePress,
    } = this.props;

    clearAssignInfo();

    if (name === "View Profile") {
      if (userId === user.id) {
        return;
      }
      changeSelectedAction(name);
      usernamePress();
    } else {
      changeSelectedAction(name);
    }
  };

  render() {
    const { name, highlighted } = this.props;
    return (
      <li
        style={{
          background: highlighted && "#4168CA",
        }}
        className="list-content-item "
        onClick={(e) => {
          e.stopPropagation();
          this.handleClick(name);
        }}
      >
        <Button
          className="content-item content-button"
          style={{
            border: "none",
            borderRadius: "0",
            height: "40px",
            fontSize: "18px",
          }}
        >
          {name}
        </Button>
      </li>
    );
  }
}
export default OptionList;
